// extracted by mini-css-extract-plugin
export var hideEditor = "_ma-2";
export var infoIcon = "_ma-3";
export var label = "_ma-1";
export var labelContainer = "_ma-0";
export var readonlyText = "_ma-4";